<script>
    import {flagPriority} from '../../../constants.js';
    import {sgettext} from '../../../i18n.js';

    export let row;

    // This mutates the original object and is generally bad practice.
    // This implementation is being improved in the new React Improvements view

    const priorityMap = {
      "HIGH": sgettext("$$PRIORITY_HIGH$$"),
      "MEDIUM": sgettext("$$PRIORITY_MEDIUM$$"),
      "NORMAL": sgettext("$$PRIORITY_NORMAL$$"),
      "LOW": sgettext("$$PRIORITY_LOW$$"),
      "NA": sgettext("$$PRIORITY_NA$$"),
      "I1:Immediate": sgettext("$$PRIORITY_I1$$"),
      "U2:Urgent": sgettext("$$PRIORITY_U2$$"),
      "P3:User Day Defined": sgettext("$$PRIORITY_P3$$"),
      "P4:Within 02Wk": sgettext("$$PRIORITY_P4$$"),
      "P5:Within 04Wk": sgettext("$$PRIORITY_P5$$"),
      "P6:Within 08Wk": sgettext("$$PRIORITY_P6$$"),
      "P7:Within 12Wk": sgettext("$$PRIORITY_P7$$"),
      "P8:After 12Wk": sgettext("$$PRIORITY_P8$$"),
      "P1": sgettext("$$DEFECT_PRIORITY_P1$$"),
      "P2": sgettext("$$DEFECT_PRIORITY_P2$$"),
      "P3": sgettext("$$DEFECT_PRIORITY_P3$$"),
      "P4": sgettext("$$DEFECT_PRIORITY_P4$$"),
      "P5": sgettext("$$DEFECT_PRIORITY_P5$$"),
    }

    row.priority = priorityMap[row.priority]

</script>

{#if row}
  {row.priority === sgettext('$$PRIORITY_MEDIUM$$')
    ? sgettext('$$PRIORITY_NORMAL$$')
    : row.priority}
{/if}
